var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 29.3333C23.3638 29.3333 29.3334 23.3638 29.3334 16C29.3334 8.63616 23.3638 2.66663 16 2.66663C8.63622 2.66663 2.66669 8.63616 2.66669 16C2.66669 23.3638 8.63622 29.3333 16 29.3333ZM17.3334 10.6666C17.3334 11.403 16.7364 12 16 12C15.2636 12 14.6667 11.403 14.6667 10.6666C14.6667 9.93025 15.2636 9.33329 16 9.33329C16.7364 9.33329 17.3334 9.93025 17.3334 10.6666ZM16 14.6666C16.7364 14.6666 17.3334 15.2636 17.3334 16V21.3333C17.3334 22.0697 16.7364 22.6666 16 22.6666C15.2636 22.6666 14.6667 22.0697 14.6667 21.3333V16C14.6667 15.2636 15.2636 14.6666 16 14.6666Z",
    fill: "#017EA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInfo);
export default __webpack_public_path__ + "static/media/alert-info.74507f7871130b8c49b269075f2c5c6b.svg";
export { ForwardRef as ReactComponent };